const actions = {
  SET_STATE: 'reports/SET_STATE',
  GET_SUMMARY: 'reports/GET_SUMMARY',
  GET_CATEGORY: 'reports/GET_CATEGORY',
  GET_MATERIAL_REPORT: 'reports/GET_MATERIAL_REPORT',
  GET_SUB_MATERIAL_REPORT: 'reports/GET_SUB_MATERIAL_REPORT',
}
export default actions
